module.exports = __webpack_public_path__ + "static/media/R-180HD_CrossSection.3e2b1847.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/fr/R-180HD_CrossSection.png
// module id = 492
// module chunks = 0